import React, { FC } from "react";
import { Stack } from "@mui/material";
import { SsoButton, SsoButtonText } from "./Styled";
import { useLanguage } from "Utils/translations/lib";

type TextInputProps = {
  mail?: string;
};

export const MicrosoftButton: FC<TextInputProps> = ({ mail }) => {
  const { t } = useLanguage();

  return (
    <Stack>
      <SsoButton
        aria-label={t("auth.logInWithMicrosoft")}
        variant="outlined"
        sx={{ mb: "12px" }}
        size="large"
        href={`/sso-start?loginMail=${mail}`}
        disableRipple={true}
        startIcon={
          <img
            src="/assets/img/mslogo.png"
            alt={t("auth.microsoftLogoAlt")}
            style={{ width: 22, height: 22 }}
          />
        }
      >
        <SsoButtonText>{t("auth.logInWithMicrosoft")}</SsoButtonText>
      </SsoButton>
    </Stack>
  );
};
